export const  homeFeatures = [
        {
            icon: "/open-book.svg",
            text: "Hands on lessons for all levels",
            caption: 'STEM courses'
        },
        {
            icon: "/tools.svg",
            text: "Learn by doing with tailored tools",
            caption: 'Projects'
        },
        {
            icon: "/globe.svg",
            text: "Connect with learners everywhere",
            caption: 'Global Classroom'
        },
        {
            icon: "/idea.svg",
            text: "Share your STEM projects",
            caption: "Inovator's Corner"
        },

    ]